<template>
    <div
        class="t-shops-row"
        :class="[
            { 't-shops-row--active': shopCheckbox },
            { 't-shops-row--disabled': isLimitReached },
            { 't-shops-row--disabled': isClosingDateBeforePromoEnd }
        ]"
    >
        <div
            style="width: var(--width); --width: 100%;"
            class="d-flex flex-column flex-sm-row justify-content-between gap-1"
        >
            <div>
                <div class="d-flex gap-0-5">
                    <ui-checkbox-input
                        class="text-primary text-sm"
                        :name="`merchant-${merchantId}`"
                        v-model="shopCheckbox"
                        :disabled="isLimitReached"
                        @click.native.stop="onShowLimitInfo"
                        :label="setShopLabel"
                    />
                    <a-icon
                        v-if="userLocation && userLocation.closing_date"
                        icon="Warning"
                        class="text-warning"
                        v-tooltip="
                            `Data wypowiedzenia: ${$moment(
                                userLocation.closing_date
                            ).format('DD-MM-YYYY')}`
                        "
                    />
                </div>
                <transition-group name="slide-fade">
                    <div
                        class="pl-4 mt-1 text-danger text-sm"
                        v-show="showLimitInfo"
                        :key="1"
                    >
                        Osiągnięto limit promocji własnych dla tego sklepu.
                    </div>
                    <div
                        class="pl-4 mt-1 text-danger text-sm"
                        v-show="showClosingDateInfo"
                        :key="2"
                    >
                        Data obowiązywania promocji wykracza poza datę
                        wypowiedzenia sklepu
                    </div>
                </transition-group>
            </div>
            <div
                class="t-shops-row__limits text-primary nowrap text-sm text-right"
                :class="{
                    'text-danger': isLimitReached
                }"
                v-if="limits"
            >
                Limit: {{ limits.active_promotions }} /
                {{ limits.retailer_promos_limit }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showLimitInfo: false,
            showClosingDateInfo: false
        }
    },
    props: {
        merchantId: {
            type: Number,
            required: true
        },
        selectedMerchants: {
            type: Array,
            default: () => []
        },
        selectMerchant: {
            type: Function,
            default: () => {}
        },
        displayLimits: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        merchant() {
            return this.$store.getters.getMerchantById(this.merchantId)
        },
        groupMerchants() {
            return true
        },
        shopCheckbox: {
            get() {
                return !!this.selectedMerchants.find(
                    merchant => merchant.id === this.merchantId
                )
            },
            set(value) {
                if (this.limits && this.isLimitReached) return
                this.selectMerchant({
                    value,
                    merchantId: this.merchantId
                })
            }
        },
        limits() {
            return this.$store.getters.getNetworksLimitsByMerchantId(
                this.merchantId
            )
        },
        isLimitReached() {
            return (
                this.limits &&
                +this.limits.active_promotions >=
                    +this.limits.retailer_promos_limit
            )
        },
        isClosingDateBeforePromoEnd() {
            const newPromo = this.$store.getters.getNewPromoForm
            if (!newPromo) return false
            const promoEnd = newPromo.step1.end_at.value
            // eslint-disable-next-line camelcase
            if (this.userLocation?.closing_date) {
                return this.$moment(this.userLocation.closing_date)
                    .subtract(1, 'days')
                    .isBefore(this.$moment(promoEnd))
            } else {
                return false
            }
        },
        setShopLabel() {
            const data = this.merchant
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        },
        userLocation() {
            return this.$store.getters.getUserLocationById(
                this.merchant.location_id
            )
        }
    },
    methods: {
        onShowLimitInfo() {
            if (this.isLimitReached) {
                if (this.shopCheckbox) {
                    this.selectMerchant({
                        value: false,
                        merchantId: this.merchantId
                    })
                } else {
                    this.showLimitInfo = true
                    setTimeout(() => {
                        this.showLimitInfo = false
                    }, 3000)
                }
            }
            if (this.isClosingDateBeforePromoEnd && !this.shopCheckbox) {
                this.showClosingDateInfo = true
                setTimeout(() => {
                    this.showClosingDateInfo = false
                }, 3000)
            }
        }
    }
}
</script>
